import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslation } from 'react-i18next';

const FAQSection = () => {
  const { t } = useTranslation();

  const faqs = [
    {
      question: t('faq.items.timeline.question'),
      answer: t('faq.items.timeline.answer')
    },
    {
      question: t('faq.items.pricing.question'),
      answer: t('faq.items.pricing.answer')
    },
    {
      question: t('faq.items.technologies.question'),
      answer: t('faq.items.technologies.answer')
    },
    {
      question: t('faq.items.support.question'),
      answer: t('faq.items.support.answer')
    },
    {
      question: t('faq.items.process.question'),
      answer: t('faq.items.process.answer')
    }
  ];

  return (
    <section id="faq" className="py-20 px-6 relative">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 text-glow-cyber">
            <span className="bg-gradient-cyber bg-clip-text text-transparent">
              {t('faq.title')}
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t('faq.subtitle')}
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="glass border-glow rounded-lg px-6 data-[state=open]:ring-2 data-[state=open]:ring-cyber-blue/20"
            >
              <AccordionTrigger className="text-left hover:no-underline py-6 text-lg font-semibold">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
